import { Button, styled } from "@mui/material"

const SmartschoolButton = styled(Button)`
  background: rgb(254, 130, 14);
  background: linear-gradient(180deg, rgba(254, 130, 14, 1) 0%, rgba(241, 10, 0, 1) 100%);
  border-radius: 4px;
  &:hover {
    background: rgb(241, 10, 0, 1);
    background: linear-gradient(0deg, rgba(254, 130, 14, 1) 0%, rgba(241, 10, 0, 1) 100%);
  }
`

export default SmartschoolButton
